import { z } from 'zod';
import { MANDATORY_FIELD } from '../../../config/zodConfig';
import { IntegrationFormSchema } from '../schemas';

export const MoovsecIntegrationFormSchema = z
    .object({
        baseUrl: z.string({ message: MANDATORY_FIELD }).nonempty({ message: MANDATORY_FIELD }),
        login: z.string({ message: MANDATORY_FIELD }).nonempty({ message: MANDATORY_FIELD }),
        password: z.string({ message: MANDATORY_FIELD }).nonempty({ message: MANDATORY_FIELD }),
    })
    .merge(IntegrationFormSchema);
